import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ floorType, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[2000] flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-lg max-w-md w-full p-6 space-y-4">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
            <Icon name="AlertTriangle" size={24} color="var(--color-error)" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-text-primary mb-2">
              Delete Floor Type
            </h3>
            <p className="text-sm text-text-secondary mb-4">
              Are you sure you want to delete <span className="font-medium text-text-primary">"{floorType?.name}"</span>? This action cannot be undone and will remove this floor type from customer visualizers.
            </p>
            <div className="bg-warning/10 border border-warning/20 rounded-lg p-3">
              <div className="flex items-start gap-2">
                <Icon name="Info" size={16} color="var(--color-warning)" className="mt-0.5" />
                <p className="text-xs text-text-secondary">
                  Any customer projects using this floor type will no longer display correctly.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 pt-4 border-t border-border">
          <Button
            variant="outline"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            iconName="Trash2"
            iconPosition="left"
            iconSize={16}
          >
            Delete Floor Type
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;